import { api, guard, unwrap } from './client'

/**
 * The signed-in user's own account.
 *
 * Every call here is implicitly scoped to whoever holds the session cookie — no user id is
 * ever sent, because one that could be sent could be changed. The only id in these
 * signatures is a session's, and the server checks it belongs to the caller before acting.
 */
export const profileApi = {
  get: () => guard(async () => unwrap(await api.GET('/api/profile', {}))),

  updateDisplayName: (displayName: string) =>
    guard(async () => unwrap(await api.PATCH('/api/profile', { body: { display_name: displayName } }))),

  changePassword: (body: { current_password?: string | null; new_password: string }) =>
    guard(async () => unwrap(await api.POST('/api/profile/password', { body }))),

  sessions: () => guard(async () => unwrap(await api.GET('/api/profile/sessions', {}))),

  revokeSession: (sessionId: number) =>
    guard(async () =>
      unwrap(
        await api.DELETE('/api/profile/sessions/{session_id}', {
          params: { path: { session_id: sessionId } },
        }),
      ),
    ),

  revokeOtherSessions: () =>
    guard(async () => unwrap(await api.POST('/api/profile/sessions/revoke-others', {}))),
}
